import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const CreateLinkedSizeChartsFromShapeToStyle = declare(Controller, {
	_styleStore: null,


	/**
	 * issue request for create style size chart so as to be able to receive return value
	 * @override
	 */
	process() {
		const req = this.m_action.m_request;
		const style = this.m_urlParent;
		new PostRequest(req.m_module, req.m_operation)
			.addParameter("URL", this.m_urlNode)
			.addParameter("Style", style)
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},

	/**
     * Prompt confirmation with buttons “Convert” and “Cancel”.
     * @override
     */
	confirmAction(params: any) {
		params.materialIcon = MessageDialog.ICON_WARNING;
		params.title = locale.typeAction("SizeChart", this.getContext().ac.m_action.m_id);
		params.message = locale.typeAction("SizeChart", this.getContext().ac.m_action.m_id + "_Confirm");
		params.buttons = [MessageDialog.BUTTON_CONVERT, MessageDialog.BUTTON_CANCEL];

		this.inherited(arguments);
	},
});

export = CreateLinkedSizeChartsFromShapeToStyle;
